module.exports = __webpack_public_path__ + "img/net_des_1.a0e0ba0f.jpg";